export const apiLoadingStates = {
  DEFAULT: 0,
  LOADING: 1,
  SUCCESS: 2,
  ERROR: 3,
};

const PRIMARY_COLOR = 'fb8c00'
export const AppConfig = {
  name: 'Curio Travels',
  primaryColor: '#' + PRIMARY_COLOR,

  // DEFAULTS
  defaults: {
    product_image: `https://dummyimage.com/300x250/bddaf1/0`
  }
}

export const months = [
  'January',
  'Febryary',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export default {
  apiLoadingStates,
  AppConfig
};
